"use strict";

import Vue from 'vue'
import VueFilterNumber from '@/vue/filters/vue-filter-number'
import EventBus from '@/vue/events/event-bus'
import allBetMixin from '@/vue/mixins/allBet'
import minibet from '@/vue/components/mini-bet'

import {
  mapGetters,
} from 'vuex'

Vue.component('cstgftht', {
  components: {
    minibet,
  },
  mixins: [allBetMixin],
  name: 'cstgftht',
  template: `
    <div :id="getOddUniqueId(event)" class="odds" :class="[getOdCls(mode,betType,score,event), getClass(event, isNegative, isDiff, isUp, isClosePause)]" @click="onClickOdd($event);" > 
      <template v-if="event.od">
        <template v-if="event.od[plyType]">
          <template v-if="event.od[plyType][betType]">
            <template v-if="event.od[plyType][betType][score]">
              <span  :title="getTitle()" :class="{ 'yb-family-odds yb-number-bold match_details': (mode=='ab' || bk.includes(betType)) }">
                <template v-if="checkOddValidation(event.od[plyType][betType][score])">
                  <template v-if="betType == 7 || betType == 16">
                    <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">
                      {{ betForm.odd }}
                    </template>
                    <template v-else>
                      {{ new Number(parseFloat(event.od[plyType][betType][score])) }}
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">
                      {{ getDecimalDisplay(betForm.odd) }}
                    </template>
                    <template v-else>
                      {{ getDecimalDisplay(event.od[plyType][betType][score]) }}
                    </template>
                  </template> 
                </template>
                <template v-else>
                  <div class="icon-lock"></div>
                </template>
              </span>
              <div class="odds-arrows-wrap" v-if="mode!='ab'">
                <div class="odds-icon odds-up"></div>
                <div class="odds-icon odds-down"></div>
              </div>
            </template>
            <template v-else>
              <div class="icon-lock"></div>
            </template>
          </template>
          <template v-else>
            <div class="icon-lock"></div>
          </template>
        </template>
        <template v-else>
          <div class="icon-lock"></div>
        </template>
      </template>
    </div>
  `,
  // template: `
  //   <div>
  //     <template v-if="event.od">
  //       <template v-if="event.od[plyType]">
  //           <template v-if="event.od[plyType][betType]">
  //               <template v-if="event.od[plyType][betType][score]">
  //                 <template v-if="checkOddValidation(event.od[plyType][betType][score])">
  //                   <div class="oddsBet abcs" :class="getClass(event, isNegative, isDiff, isUp)" @click="onClickOdd($event)">
  //                     <span :class="[getOddUniqueClass(event), {ngve: isNegative, diff: isDiff}]">
  //                       <template v-if="betType == 7 || betType == 16">
  //                         <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">
  //                           {{ betForm.odd }}
  //                         </template>
  //                         <template v-else>
  //                           {{ new Number(parseFloat(event.od[plyType][betType][score])) }}
  //                         </template>
  //                       </template>
  //                       <template v-else>
  //                         <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">
  //                           {{ getDecimalDisplay(betForm.odd) }}
  //                         </template>
  //                         <template v-else>
  //                           {{ getDecimalDisplay(event.od[plyType][betType][score]) }}
  //                         </template>
  //                       </template> 
  //                     </span>
  //                     <minibet v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))"></minibet>
  //                   </div>
  //                 </template>
  //               </template>
  //           </template>
  //       </template>
  //     </template>
  //   </div>
  // `,
  props: {
    event: null,
    score: null,
    plyType: null,
    betType: null,
    decimalNumber: null,
    mode: null, //ab = allbet
  },
  computed: {
    ...mapGetters([
      'sportMiniBet',
    ]),
    betForm() {
      return this.$store.getters.betForm[0]
    },
  },
  watch: {
    'event': {
      handler(val, oldVal) {
        if (typeof val.od != 'undefined') {
          if (typeof val.od[this.plyType] != 'undefined') {
            if (typeof val.od[this.plyType][this.betType] != 'undefined') {
              if (typeof val.od[this.plyType][this.betType][this.score] != 'undefined') {
                this.classNegative(val.od[this.plyType][this.betType][this.score])
                //check if immediate call
                if (oldVal && !this.refreshOdd) {
                  this.refreshOdd = false
                  if (typeof oldVal.od[this.plyType] != 'undefined') {
                    if (typeof oldVal.od[this.plyType][this.betType] != 'undefined') {
                      if (typeof oldVal.od[this.plyType][this.betType][this.score] != 'undefined') {
                        this.diffOddsUpDown(val.od[this.plyType][this.betType][this.score], oldVal.od[this.plyType][this.betType][this.score])
                        this.diffOdds(val.od[this.plyType][this.betType][this.score], oldVal.od[this.plyType][this.betType][this.score])
                      }
                    }
                  }
                } else if (this.refreshOdd) {
                  this.refreshOdd = false
                  this.isDiff = false
                } else if (!oldVal) { //when not same template
                  this.refreshOdd = true
                }
              } else {
                this.isClosePause = true
              }

            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isNegative: false,
      isDiff: false,
      isClosePause: false,
      refreshOdd: false,
      isUp: false,
      bk: ['6','25','53','54','55','56']
    }
  },
  methods: {
    getOdCls(mode, bt, score, event) {
      var a = ' odds-default'
      if (mode == 'ab') {
        a = 'yb-number-font'
        if(score=='aos'){
          a = a + ' aosnoflex ab-right'
        }
        a = a + ' odds-default'
        if(event.sprtid=='1'){
          a = a + ' odds-sc'
        } else {
          a = a + ' odds-os'
        }
      } else {
        if(jQuery.inArray(bt, ['25']) != '-1'){
          a += ' c-center'
        } else {
          a += ' c-right'
        }
        
      }
      //style="position: absolute;inset: 0px; justify-content:right" :style="{'margin-right':event.sptid==1 ? '10px':'15px' }"
      return a
    },
    getClass(windowEvent, isNeg, isDif, isUp, isClosePause) {
      var classStr = ''
      var classMini = ''
      // if (this.sportMiniBet.allow && this.sportMiniBet.toggle && this.checkMiniBetUnique(windowEvent, this.getOddUniqueId(windowEvent))) {
      //   classMini = ' selected panelActive'
      //   if (this.sportMiniBet.rightside) {
      //     classMini = ' selected panelActive-bottomRight'
      //   }
      //   if (this.betForm.oddChg) {
      //     classStr = 'indicator'
      //   }
      // }
      if (this.changeOdds) {
        if (!this.refreshOdd && isDif) {
          classStr = 'indicator'  //indicatorUp
        }
      } else if (isClosePause) {
        classStr = ''
      } else {
        if (!this.refreshOdd && isDif) {  //refresh
          if (isUp) {
            classStr = 'up'
            // classStr = 'indicatorUp'
          } else {
            classStr = 'down'
            // classStr = 'indicatorDown'
          }
        }
      }
      return classStr + classMini
    },
    onClickOdd(windowEvent = null) {
      EventBus.$emit('returnBetTab')
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return
      }
      if (!this.account.previewFlag) {
        if (!this.checkOddValidation(this.event.od[this.plyType][this.betType][this.score])) {
          return
        }
        var tg = {
          "1": {
            "tg01": this.$store.getters.sportAllBetLang['ALL_BET.LBL_01'],
            "tg23": this.$store.getters.sportAllBetLang['ALL_BET.LBL_23'],
            "tg456": this.$store.getters.sportAllBetLang['ALL_BET.LBL_46'],
            "tg7": this.$store.getters.sportAllBetLang['ALL_BET.LBL_7more'],
            // "tg7": this.$store.getters.sportAllBetLang['ALL_BET.LBL_7more'] + '+',
          },
          "2": {
            "tg01": this.$store.getters.sportAllBetLang['ALL_BET.LBL_0'],
            "tg23": this.$store.getters.sportAllBetLang['ALL_BET.LBL_1'],
            "tg456": this.$store.getters.sportAllBetLang['ALL_BET.LBL_2'],
            "tg7": this.$store.getters.sportAllBetLang['ALL_BET.LBL_3more'],
            // "tg7": this.$store.getters.sportAllBetLang['ALL_BET.LBL_3more'] + '+',
          },
        };

        var correct_score = this.score.split("")
        var display = ""
        //o,aos = cs, t = tg, else htft
        if (correct_score[0] === 'o' || this.score == 'aos') {
          if (this.score == 'aos')
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AOS']
          else
            display = correct_score[2] + " - " + correct_score[3]
        } else if (correct_score[0] === 't') {
          display = tg[this.plyType][this.score]
        } else { //htft
          if (correct_score[0] === 'h' && correct_score[1] === 'h') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']
          } else if (correct_score[0] === 'h' && correct_score[1] === 'd') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH']
          } else if (correct_score[0] === 'h' && correct_score[1] === 'a') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']
          } else if (correct_score[0] === 'd' && correct_score[1] === 'h') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']
          } else if (correct_score[0] === 'd' && correct_score[1] === 'd') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH']
          } else if (correct_score[0] === 'd' && correct_score[1] === 'a') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']
          } else if (correct_score[0] === 'a' && correct_score[1] === 'h') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']
          } else if (correct_score[0] === 'a' && correct_score[1] === 'd') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH']
          } else if (correct_score[0] === 'a' && correct_score[1] === 'a') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']
          }
        }
        //var teamBet = this.team[this.team.length -1];
        var betForm = {
          title: this.$store.getters.selectedBettype.sprtTitleLang,
          eveid: this.event.eveid,
          league: this.event.lgecapt,
          sprtid: this.event.sptid,
          plyType: this.plyType,
          betType: this.betType,
          ta: this.event.tacapt,
          tb: this.event.tbcapt,
          taid: this.event.taid,
          tbid: this.event.tbid,
          tbet: this.score,
          tbetcapt: display,
          odd: this.event.od[this.plyType][this.betType][this.score],
          rbscoa: 0,
          rbscob: 0,
          dual: 'a', //TODO check is needed
          fav: '0',
          hdp: '0',
          uniqueId: this.event.eveid + this.plyType + this.betType + this.score,
          eventObj: this.event
        }

        if (this.event.rb) {
          if (this.event.rbinfo) {
            betForm.rbscoa = this.event.rbinfo.scoa
            betForm.rbscob = this.event.rbinfo.scob
          }
        }

        if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
          var market = this.$store.getters.market.inPlayMarket
          // betForm.plyType = '(' + market.betLang + ') ' + this.plyType
        } else if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {
          //    betForm.title = this.$store.getters.selectedBettype.sprtTitleLang + ' - ' + this.$store.getters.market.earlyMarket.betLang
        }

        // Check if current sel has selected, if true remove else add
        var indexx = _.findIndex(this.$store.getters.betForm, {
          'eveid': this.event.eveid,
          'plyType': this.plyType,
          'betType': this.betType,
          // 'dual': this.matchId,
          'tbet': this.score,
        });
        if(indexx > -1){
          var obj = {eveid: this.event.eveid}
          if(this.$store.getters.isBetCombo){
            obj = {clearType: '3', index: indexx}
          }
          this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
          this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

          this.$store.dispatch("removeMatch", {
            // eveid: this.event.eveid,
            data: obj,
            callback: (() => {
              this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: this.event.eveid,
              });
              var MID = $(windowEvent.target).closest('div[id]')[0].id
              $("[id="+MID+"]").closest('.c-bet-item.active').removeClass('active')
              if (this.$store.getters.betForm.length <= 0) {
                this.$store.commit("OPEN_BETFORM", false)
                this.$store.commit('ODD_SELECTED', false)
                this.$store.commit("SHOW_BETFORM_MENU", false);
                this.$store.commit('SELECTED_TAB', 'betTab')
                return;
              } else {
                this.$store.commit('OPEN_BETFORM', true)
              }
              this.$store.dispatch("getBettingInfo", {
                callback: ((res) => {
                  this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: this.$store.getters.betForm,
                  });
                  // this.refreshTimer();
                  // this.isReloading = false;
                }).bind(this),
              });
            }).bind(this),
          });
        } else {
          //betcombo validate max betcombo wager
          if(this.$store.getters.isBetCombo && this.$store.getters.betForm.length==this.betComboMax){
            var chkRes = this.checkBetComboMax(betForm)
            if(chkRes){
              return
            }
          }
          // parlay
          if(this.$store.getters.selectedBettype.betTypId == '5' && this.$store.getters.betting.minMax!=undefined && this.$store.getters.betting.minMax.maxCombo!=undefined){
            if(this.$store.getters.betForm.length==this.$store.getters.betting.minMax.maxCombo){
              let vue = this
              let maxMulpComboMsg = this.$store.getters.betLang['BETTING.HIT_MAX_COMBO']
              this.$store.commit('DIALOG_TOGGLE',{
                show: true,
                msg: maxMulpComboMsg
              })
              // this.$store.commit('JS_ERR', {error:true, msg:maxMulpComboMsg})
              setTimeout(function() {
                // vue.$store.commit('JS_ERR', {error:false})
                vue.$store.commit('DIALOG_TOGGLE', {reset:true})
              }, 5000);
              return
            }
          }

          this.$store.dispatch('getLatestInfo', {
            data: betForm,
            callback: ((res) => {
              this.$store.commit('CLEAR_BET_SUCCESS')
              this.$store.commit('OPEN_BETFORM', true)
              this.oddSelectHighlight(windowEvent, betForm)

              if (res.SYSTEM_DATA.status != 'FAIL') {
                if(this.$store.getters.miniNormal==1){
                  this.showMiniBet(windowEvent);
                  if(this.$store.getters.sportMiniBet.toggle){
                    EventBus.$emit('expandMini')
                  }
                }
                if(!this.$store.getters.isBetCombo){
                  this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
                  EventBus.$emit('resetKeyboard')
                }

                this.$store.commit('ODD_SELECTED', true)
                // this.$store.commit('SELECTED_BETTAB', true)
                // this.$store.commit('OPEN_BETFORM', true)
                this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                })
                //multisingle & > 1 wager
                if(this.$store.getters.isBetCombo && this.$store.getters.betForm.length>1){ 
                  EventBus.$emit('clearAllBetComboAmount');
                  EventBus.$emit('resetKeyboard')
                }
                if (windowEvent) {
                  this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: this.event.eveid
                  })
                }
              } else if (res.SYSTEM_DATA.status == 'FAIL') {
                // } else if (res.SYSTEM_DATA.status == 'FAIL' && res.SYSTEM_DATA.code == 'S-4-S') {
                if(this.$store.getters.miniNormal==1){
                  this.showMiniBet(windowEvent);
                }
                
                if(!this.$store.getters.isBetCombo){
                  this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
                }
                this.$store.commit('ODD_SELECTED', true)
                // this.$store.commit('SELECTED_BETTAB', true)
                this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                })
                if (windowEvent) {
                  this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: this.event.eveid
                  })
                }
              }
  
            }).bind(this)
          })
        }
        
      }
    },
    classNegative(val, oldVal) {
      this.isNegative = val < 0 ? true : false
    },
    diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false
    },
    diffOddsUpDown(val, oldVal) {
      this.isUp = parseFloat(val) > parseFloat(oldVal) ? true : false
    },
    getOddUniqueClass(event) {
      var classStr = ''
      if (this.plyType == '2') {
        classStr += 'ht '
      }
      classStr += this.getOddUniqueId(event)
      return classStr
    },
    getOddUniqueId(event) {
      return event.eveid + this.plyType + this.betType + this.score
    },
    checkTitleBt() {
      if([this.htftBetType, this.rhtftBetType, this.wmBetType, this.rwmBetType, this.flgBetType].includes(this.betType.toString())) {
        return true
      } 
      return false
    },
    getTitle(){
      // htft
      if(this.betType == this.htftBetType || this.betType == this.rhtftBetType) {
        if(this.score == 'hh'){
          return this.event.tacapt+'/'+this.event.tacapt
        } else if(this.score == 'hd') {
          return this.event.tacapt+'/'+this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']
        } else if(this.score == 'ha') {
          return this.event.tacapt+'/'+this.event.tbcapt
        } else if(this.score == 'dh') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']+'/'+this.event.tacapt
        } else if(this.score == 'dd') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']+'/'+this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']
        } else if(this.score == 'da') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']+'/'+this.event.tbcapt
        } else if(this.score == 'ah') {
          return this.event.tbcapt+'/'+this.event.tacapt
        } else if(this.score == 'ad') {
          return this.event.tbcapt+'/'+this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']
        } else if(this.score == 'aa') {
          return this.event.tbcapt+'/'+this.event.tbcapt
        }
      }
      
      // wm
      if(this.betType == this.wmBetType || this.betType == this.rwmBetType) {
        if(this.score == 'h1'){
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HWB1']
        } else if(this.score == 'a1') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWB1']
        } else if(this.score == 'h2') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HWB2']
        } else if(this.score == 'a2') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWB2']
        } else if(this.score == 'h3') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HWB3']
        } else if(this.score == 'a3') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWB3']
        } else if(this.score == 'h4') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HWB4M']
        } else if(this.score == 'a4') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWB4M']
        } else if(this.score == 'sd') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AS']
        } else if(this.score == 'ng') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_NG']
        }
      }

      // flg
      if(this.betType == this.flgBetType) {
        if(this.score == 'hf'){
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HFG']
        } else if(this.score == 'af') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AFG']
        } else if(this.score == 'hl') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HLG']
        } else if(this.score == 'al') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_ALG']
        } else if(this.score == 'ng') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_NG']
        }
      }

    },
  },
  beforeMount() {
    EventBus.$on(['refreshOdd'], ((params) => {
      if (params == false) {
        this.refreshOdd = false // change market, change page, change parlayEarlyDate
      } else {
        this.refreshOdd = true // change odd type, refresh button
      }
    }).bind(this))
  },
  mounted(){
    this.$store.getters.betForm.forEach(value => {
      var MID = value.uniqueId;
      $("[id="+MID+"]").closest('.c-bet-item').addClass('active')
    })
  }
});



// WEBPACK FOOTER //
// ./resources/wob/vue/components/cs-tg-ftht.js